import { deskCard, deskEyebrow, deskMuted, deskSecondaryBtn } from "./salesDeskStyles";
import type { SalesDeskStockRequest } from "./salesDeskStockRequest";

export function SalesDeskRestock({
  requests,
  onOpenSale,
}: {
  requests: SalesDeskStockRequest[];
  onOpenSale: (saleId: string) => void;
}) {
  return (
    <div>
      <p className={deskEyebrow}>Manager</p>
      <h1 className="mt-2 text-[32px] font-semibold leading-[1.15] tracking-[-1px]">Stock requests</h1>
      <p className={`mt-3 max-w-[40rem] ${deskMuted}`}>Separate from customer sales and approvals.</p>
      {requests.length === 0 ? <p className={`mt-8 ${deskMuted}`}>No stock requests yet.</p> : null}
      <div className="mt-6 grid grid-cols-1 gap-4">
        {requests.map((request) => {
          const spec = [request.size, request.color, request.electrical].filter(Boolean).join(" · ");
          return (
            <article key={request.id} className={deskCard}>
              <p className="inline-flex rounded-full bg-[#eef1e7] px-2.5 py-1 text-[11px] font-semibold text-[#164b43] dark:bg-zinc-800 dark:text-emerald-200">
                Not sent
              </p>
              <h2 className="mt-3 text-[21px] font-semibold">
                {request.id} · {request.sourceLabel}
              </h2>
              <p className={`mt-2 ${deskMuted}`}>Destination: {request.destinationLabel}</p>
              {spec ? <p className={`mt-1 ${deskMuted}`}>{spec}</p> : null}
              <p className={`mt-1 ${deskMuted}`}>
                Evidence: {request.evidenceIds.length > 0 ? request.evidenceIds.map((id) => id.slice(0, 8)).join(", ") : "None attached"}
              </p>
              <button type="button" onClick={() => onOpenSale(request.sourceSaleId)} className={`${deskSecondaryBtn} mt-4`}>
                Return to pending sale
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}
